import React from 'react';
import { Link } from 'react-router-dom';

function Button(props) {
    return (
        <Link className={`button button-${props.type}${props.className ? ' ' + props.className : ''}`} to={`${props.link}`}>
            {props.content}
        </Link>
    );
}

export default Button;
